<rt-collapsible-card
  rtCollapsibleCardAnalytics
  analyticsKey="contact"
  uniqKey="candidate-contact-card"
  [hasHeaderDivider]="true"
>
  <div leftSlot layout layout-align-items-center>
    <rt-heading>
      {{ 'app.candidate.contact' | translate }}
    </rt-heading>
  </div>
  @if (canSendMessages()) {
    <div rightSlot layout layout-align-items-center>
      <rt-button
        variant="plain"
        size="small"
        (click)="$event.stopImmediatePropagation(); sendMessageClick.emit()"
      >
        <rt-icon name="mail-outline"></rt-icon>
        {{ 'app.candidate.send_message' | translate }}
      </rt-button>
    </div>
  }
  <div [class.editing]="!!editingName" collapsible layout-full-width padding-tb-small-xx>
    @for (field of fields(); track field.key) {
      <rt-candidate-field-row
        name="{{ field.name }}"
        [copyable]="field.copyable"
        [editable]="field.editable"
        [field]="field.field"
        [displayInline]="field.displayInline"
        [fieldDisplayTpl]="field.displayTpl"
        [fieldEditTpl]="editTpl"
        [editing]="editingName === field.key"
        [tooltipEnabled]="!!field.tooltipEnabled"
        [tooltipText]="field.tooltipText"
        [wrap]="field.key === InformationField.SocialLinks"
        [class.editing]="editingName === field.key"
        (edit)="setEditingName(field.key)"
        [attr.data-cy]="'rt-candidate-field-row:' + field.key"
      />
      <ng-template #editTpl>
        <rt-profile-information-edit
          [group]="formGroup"
          [arrayName]="field.key"
          [arrayControls]="$any(formGroup.controls[field.key])"
          [loading]="loading()"
          [editPhoneNumber]="field.key === InformationField.Phones"
          [errorText]="field.errorText || ''"
          [countryCode]="countryCode()!"
          [hasNewStyling]="true"
          (save)="handleSave($event)"
          (add)="handleAdd($event)"
          (removeItem)="handleRemove($event)"
          (cancel)="setEditingName(null)"
        >
        </rt-profile-information-edit>
      </ng-template>
    }
  </div>
</rt-collapsible-card>

<ng-template #phoneTpl let-value="value" let-isValid="isValid">
  <a text-darkest href="tel:{{ value }}">
    <p>
      {{ value | rtPhoneNumber }}
    </p>
  </a>
  @if (!isValid) {
    <rt-icon
      [rtTooltip]="'app.candidate.texting.phone_number_invalid' | translate"
      margin-left-small-x
      name="error-outline"
      cursor-default
    ></rt-icon>
  }
</ng-template>
<ng-template #emailTpl let-value="value">
  <p class="link" (click)="canSendMessages() && sendMessageClick.emit()">
    {{ value }}
  </p>
</ng-template>
<ng-template #socialLinkTpl let-value="value" let-isLast="isLast">
  <span class="social-link" [class.is-last]="isLast">
    @let socialMedia = value | rtSocialMedia: true | ngrxPush;
    <a [href]="value" target="_blank"> <img [src]="socialMedia?.icon" />{{ socialMedia?.name }}</a>
  </span>
</ng-template>
<ng-template #anonymizedSocialLinkTpl let-value="value" let-isLast="isLast">
  <span
    [rtTooltip]="'app.candidate.contact_card.anonymized_tooltip' | translate"
    rtTooltipPosition="right"
    class="social-link"
    [class.is-last]="isLast"
  >
    @let socialMedia = value | rtSocialMedia: true | ngrxPush;
    <img [src]="socialMedia?.icon" [class.anonymized]="anonymized()" />{{ socialMedia?.name }}</span
  >
</ng-template>
<ng-template #linkTpl let-value="value">
  <rt-link-wrapper [content]="value" forceNoProtocol="true"></rt-link-wrapper>
</ng-template>
<ng-template #anonymizedTpl let-value="value">
  <p
    [rtTooltip]="'app.candidate.contact_card.anonymized_tooltip' | translate"
    rtTooltipPosition="right"
    class="anonymized-tpl"
  >
    {{ value }}
  </p>
</ng-template>
